import React, { FC, forwardRef } from "react";
import { Control } from "react-hook-form";

import SwitchBase, { SwitchProps } from "@/components/ui/Form/Switch/SwitchBase";
import SwitchControlled from "@/components/ui/Form/Switch/SwitchControlled";

interface DynamicInputProps extends SwitchProps {
  control?: Control<any>;
}

const Radio = forwardRef<HTMLInputElement, DynamicInputProps>((args, ref) => {
  return <>{args?.control ? <SwitchControlled control={args.control} {...args} /> : <SwitchBase {...args} />}</>;
});
Radio.displayName = "Radio";
export default Radio;
